<template>
    <div style="background-color: aqua;">
        

    <el-row type="flex" justify="space-between">
            <el-col :span="6"><div class="iconfont icon-xitongcanshu-05"
                style="font-size: 22px;"
                ></div>
            </el-col> 

            <el-col :span="18">
                <el-row type="flex" justify="end">
                        <el-col :span="6">  
                            <div 
                            
                            style="text-align: center;padding: 2px;
                            border-left: 1px solid gray;
                            "
                 
                            >{{currentTime}}</div>
                            
                        </el-col>
                        <el-col :span="3">  
                            <div 
                            class="text-el1"
                            style="text-align: center;padding: 2px;
                            border-left: 1px solid gray;
                            "
                     
                            >欢迎:{{ username }}</div>
                            
                        </el-col>

                        <el-col :span="1">
                            <div class="iconfont icon-guanbi"
                            style="font-size: 22px;text-align: right;padding: 2px;
                            border-left: 1px solid gray;
                            "
                            @click="logout_evt"
                            ></div>
                        </el-col>

                         
                       
                       
                </el-row>
            </el-col>
    </el-row>

    </div>
 
</template>

<script>
import {mapGetters,mapMutations,mapActions,mapState} from 'vuex'
import dayjs from 'dayjs'
export default {
    data(){
        return {
            // 存储格式化后的时间
            currentTime: '',
            timer:null
        }
    },
    // 页面挂载完成后启动定时更新
    mounted() {
        this.currentTime=dayjs().format('YYYY-MM-DD HH:mm:ss')
        // 每秒执行一次updateTime方法
        this.timer = setInterval(() => {
            this.currentTime=dayjs().format('YYYY-MM-DD HH:mm:ss')
        }, 1000)
    },
    methods:{
          ...mapMutations(['RESET_ALL_STATE']),
        async logout_evt(){
            const res=await  this.$confirm('确定要退出吗,?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            })
            this.RESET_ALL_STATE()
            this.$router.push('/login')
            this.$message.success('退出成功')
         
        }
    },
    computed:{
        ...mapState('User',['userinfo']),
        username(){
            console.log(this.userinfo,'this.userinfo')
            return this.userinfo.nickname
        }

    }
}
</script>

<style scoped lang="scss">

.text-el1 {
  @include text-ellipsis();
}
</style>